var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22.351,
  height: 22.351
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1291d9",
  d: "M21.051 9.877a1.3 1.3 0 0 0-1.3 1.3 8.57 8.57 0 1 1-2.527-6.084l-1.523.02a1.3 1.3 0 0 0 .033 2.6l4.321-.055a1.3 1.3 0 0 0 .915-.392 1.3 1.3 0 0 0 .369-.923l-.057-4.55a1.3 1.3 0 0 0-2.6.033l.014 1.1a11.161 11.161 0 1 0 3.654 8.245 1.3 1.3 0 0 0-1.299-1.294"
})));
export { SvgRefresh as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.8f7716a3.svg";